import React from 'react';
import { FormText, LoadingIndicator } from '@milanote/roma';

import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { LabelUsageDataState } from './useLabelUsageData';

type LabelUsageTextProps = {
    className?: string;
    onUsageLinkClick: React.MouseEventHandler<HTMLAnchorElement>;
    usageDataState: LabelUsageDataState;
};

/** Renders the translated label usage copy with a clickable usage search link. */
const LabelUsageText: React.FC<LabelUsageTextProps> = ({ className, onUsageLinkClick, usageDataState }) => {
    const translate = useTranslator('popup', 'labels.edit');

    return (
        <FormText size="sm" color="quaternary" className={className}>
            {usageDataState.status === 'fetching' ? (
                <LoadingIndicator size="xxs" className="text-quaternary">
                    {translate('usedFetching')}
                </LoadingIndicator>
            ) : (
                translate(
                    'used',
                    {
                        count: usageDataState.count,
                        context: usageDataState.status === 'error' ? 'error' : undefined,
                    },
                    {
                        components: {
                            usageLink: <a href="#" onClick={onUsageLinkClick} />,
                        },
                    },
                )
            )}
        </FormText>
    );
};

export default LabelUsageText;
